import Utils from "../utils/Utils";

const PaymentController = {
  getPaymentAnalytics: ({ Authorization, fromDate, companyId, toDate }) => {
    const params = new URLSearchParams();

    if (fromDate) params.append("fromDate", fromDate);
    if (companyId) params.append("companyId", companyId);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      "api/payment/v1/getPaymentAnalytics",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },

  getPaymentOverview: ({ Authorization, fromDate, companyId, toDate }) => {
    const params = new URLSearchParams();

    if (fromDate) params.append("fromDate", fromDate);
    if (companyId) params.append("companyId", companyId);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      "api/payment/v1/getPaymentOverview",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },

  getBusinessPaymentOverview: ({
    Authorization,
    fromDate,
    companyId,
    toDate,
  }) => {
    const params = new URLSearchParams();

    if (fromDate) params.append("fromDate", fromDate);
    if (companyId) params.append("companyId", companyId);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      "api/payment/v1/getBusinessPaymentOverview",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
  getAdminPayments: ({
    Authorization,
    fromDate,
    page,
    search,
    size,
    sortBy,
    sortDirection,
    status,
    toDate,
  }) => {
    const params = new URLSearchParams();

    if (fromDate) params.append("fromDate", fromDate);
    if (page) params.append("page", page);
    if (search) params.append("search", search);
    if (size) params.append("size", size);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDirection) params.append("sortDirection", sortDirection);
    if (status) params.append("status", status);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      "api/payment/v1/getAdminPayments",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },

  getBusinessPayments: ({
    Authorization,
    companyId,
    fromDate,
    page,
    search,
    size,
    sortBy,
    sortDirection,
    status,
    toDate,
  }) => {
    const params = new URLSearchParams();

    if (companyId) params.append("companyId", companyId);
    if (fromDate) params.append("fromDate", fromDate);
    if (page) params.append("page", page);
    if (search) params.append("search", search);
    if (size) params.append("size", size);
    if (sortBy) params.append("sortBy", sortBy);
    if (sortDirection) params.append("sortDirection", sortDirection);
    if (status) params.append("status", status);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      "api/payment/v1/getBusinessPayments",
      "",
      "GET",
      params.toString(),
      true,
      Authorization,
      true,
    );
  },
};

export default PaymentController;
